import { INFO_BLUE } from "../../constants/colors";

const bannerBackgroundColor = INFO_BLUE;

export const fallbackValues = {
  bannerBackgroundColor
};
